import cloneDeep from 'lodash/cloneDeep';
import { getRequestData, failAlert } from '@/utils';
import { checkVirtualToFixed, changeMainProdBsnl } from '@/pages/VirtualConvertToFixedLine/services/virtualConvertToFixedLine';

const defaultState = {
  step: 0, // 虚拟换固定的步骤
  searchCustInfo: {}, // 从搜索页面同步过来的用户信息
  serviceType: {}, // 从搜索页面同步过来的服务类型
  subServiceType: {}, // 从搜索页面同步过来的子服务类型
  custAddrList: [], // 当前客户下的地址列表
  POACertTypeList: [], // 地址证明信息里可选的证件类型
  poaDefaultFileList: [],
  offerDtoList: [],
  acctDetail: {},
  acctDtoList: [],
  newSubsPlan: {}, // 新的主套餐
  deliveryMethodList: [],
  billingCycleTypeList: [],
  accountInfo: {},
  pageInfo: { pageCount: 5 },
  totalRecord: 0,
};

export default {
  namespace: 'virtualConvertToFixedLine',
  state: cloneDeep(defaultState),
  effects: {
    *checkVirtualToFixed({ payload }, { call, put }) {
      const checkResult = yield call(checkVirtualToFixed, payload);
      const { changeFlag, accNbrFlag, acctNbrFlag, returnCode, returnMsg } = getRequestData(checkResult, false) || {};
      if (`${returnCode}` !== '0') {
        // 提示后端check内容
        failAlert({ title: '', content: returnMsg });
      }
      yield put({
        type: 'save',
        payload: { changeFlag, accNbrFlag, acctNbrFlag },
      });
      return { changeFlag, accNbrFlag, acctNbrFlag };
    },
    *changeMainProdBsnl({ payload }, { call }) {
      const result = yield call(changeMainProdBsnl, payload);

      return getRequestData(result, false);
    },
  },

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    clear() {
      return cloneDeep(defaultState);
    },
  },
};
